import React from 'react';
import { Box, Divider, Heading } from 'bumbag';
import _get from 'lodash/get';

import { InstalmentPlanSchedule } from '@medipass/react-core';
import { FUTURE_TYPES } from '@medipass/utils/constants';
type Props = {
  transaction: Record<string, any>;
};
export default function FutureDetails(props: Props) {
  const { transaction } = props;
  return (
    <Box>
      {transaction.futureType === FUTURE_TYPES.HOLD && (
        <React.Fragment>
          <Heading use="h5">Payment hold</Heading>
          <Divider />
          This payment hold is valid for 7 days.
        </React.Fragment>
      )}
      {transaction.futureType === FUTURE_TYPES.INSTALMENT_PLAN && (
        <InstalmentPlanSchedule
          isCompact
          paymentSchedule={_get(transaction, 'instalmentPlan.paymentSchedule', [])}
          showDueNow
        />
      )}
    </Box>
  );
}
